import { HelpMessage } from 'utils/constants'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { CASType } from '../../../CASTypesContext/types'
import { useOptionalDescriptionColumn } from 'components/CIMSTable/common/hooks/useDescriptionColumn'

export const useColumns = (): CIMSColumn<CASType>[] => {
  return [
    useNameColumn({
      help: HelpMessage.CAS.Types.Name,
      sort: { default: 'ascend' },
    }),
    useOptionalDescriptionColumn('Type'),
  ]
}
